import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-styled-flexboxgrid';
import Page from '../components/Page';
import Icon from '../assets/kamerasprechblase.gif';

// STYLES
const IconImage = styled.img`
  width: 100px;
  float: right;
  margin-top: 1rem;
`;

const StyledFigcaption = styled.figcaption`
  float: right;
`;

const Text = styled.div`
  font-weight: bold;
`;

// COMPONENT
const UeberMich = props => {
  
  const { data } = props;

  return (
    <Page title="Über mich">
      <Row>
        <Col xs={12} sm={6}>
          <figure className="clearfix">
            <img src={ process.env.REACT_APP_ROOT + data.image.path } alt="" />
            <StyledFigcaption>Fotos: Alois Pribil</StyledFigcaption>
          </figure>
          <IconImage src={ Icon } alt="" />
        </Col>
        <Col xs={12} sm={6}>
          <Text dangerouslySetInnerHTML={{ __html: data.text }}></Text>
        </Col>
      </Row>
    </Page>
  );
};

export default UeberMich;